import { Component, OnDestroy, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';

import { config } from "../../../config/index";

import { DocusignApprovalCompleteService } from './docusign-approval-complete.service';
import { SnackbarService } from "../shared/services/snackbar.service";
import { SessionStorageService } from '../shared/services/session-storage.service';

@Component({
    template: require('./docusign-approval-complete.component.html'),
    styles: [require('./docusign-approval-complete.component.less')],
    providers: [DocusignApprovalCompleteService, SessionStorageService, SnackbarService],
    preserveWhitespaces: true
})

export class DocusignApprovalCompleteComponent implements OnInit, OnDestroy {

    id: number;
    token: any;
    loading: boolean = false;
    docusignEvent: any;
    backToUrl: string;

    apiSubscriptions: Subscription[] = [];

    constructor(
        private _docusignCompleteService: DocusignApprovalCompleteService,
        private _sessionStorageService: SessionStorageService,
        private activatedRoute: ActivatedRoute,
        private _mdlSnackbarService: SnackbarService,
        private _router: Router,
        @Inject('utilService') private utilService: any,
    ) { }

    ngOnInit() {
        this.activatedRoute.params.subscribe(params => {
            this.id = params['id'];
        });
        this._sessionStorageService.readItem(config.storage_key).then(
            (data: any) => this.token = data.token
        );
        this._sessionStorageService.readItem('approval_from_url').then(
            (data: any) => this.backToUrl = data
        );
        this.activatedRoute.queryParams.subscribe(queryParams => {
            this.docusignEvent = queryParams['event'];
        });
        let reqData = {
            id: this.id,
        };
        this.loading = true;
        let selectedRole, defaultRole;
        this._sessionStorageService.readItem(config.role).then((data: any) => {
            if (data) {
                selectedRole = data.selectedRole;
                defaultRole = data.default_role;
            } else {
                selectedRole = null;
                defaultRole = null;
            }
            this.apiSubscriptions.push(this._docusignCompleteService.docusignComplete(reqData, selectedRole, defaultRole)
                .subscribe((res: any) => this.successHandler(res),
                error => this.errorHandler(error)));
        });
    }

    ngOnDestroy() {
        this.apiSubscriptions.forEach((subscription: any) => {
            subscription?.unsubscribe();
        });
    }

    navigateToTreatmentApproval() {
        this._router.navigate([this.backToUrl], { replaceUrl: true });
    }

    successHandler(res: any) {
        this.loading = false;
        if (this.docusignEvent === 'signing_complete') {
            this.utilService.contractSignedPopup.next({ signingComplete: true, id: this.id });
        } else if (this.docusignEvent === 'decline') {
            this._mdlSnackbarService.showSnackbar('TREATMENT_REVISED', 'success');
        }

        this.navigateToTreatmentApproval();
    }

    errorHandler(error: any) {
        this.loading = false;
        this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
        this.navigateToTreatmentApproval();
    }
}
